import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from '@mui/material';

const FormActions = ({
  fromSessionNotes,
  existingEntry,
  isDeleteDialogOpen,
  isDisabled,
  goalId,
  goalCollectionID,
  handleOpenDeleteDialog,
  handleCloseDeleteDialog,
  handleConfirmDelete,
  handleSubmit,
  isDeleting,
  isSaving,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {existingEntry && !fromSessionNotes && (
        <>
          <Button
            variant='contained'
            color='error'
            sx={{
              mt: 2,
              ml: 2,
              width: '120px',
              height: '40px',
              textTransform: 'capitalize',
              fontSize: '14px',
              fontWeight: 500,
              borderRadius: '6px',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={handleOpenDeleteDialog}
          >
            {isDeleting ? (
              <CircularProgress
                size={20}
                sx={{
                  color: 'white',
                }}
              />
            ) : (
              'Delete'
            )}
          </Button>

          <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
            <DialogTitle fontWeight={'bold'} fontFamily={'Lato'}>
              Confirm Deletion
            </DialogTitle>
            <DialogContent>
              <DialogContentText fontFamily={'Lato'}>
                Are you sure you want to delete this goal data-entry
                permanently?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeleteDialog} color='primary'>
                No
              </Button>
              <Button
                onClick={() => handleConfirmDelete(goalId || goalCollectionID)}
                color='error'
                autoFocus
                disabled={isDeleting}
                sx={{
                  minWidth: '64px',
                  position: 'relative',
                }}
              >
                <Box sx={{ visibility: isDeleting ? 'hidden' : 'visible' }}>
                  Yes
                </Box>
                {isDeleting && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: 'error.main',
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      marginTop: '-12px',
                      marginLeft: '-12px',
                    }}
                  />
                )}
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
      {!fromSessionNotes && (
        <Button
          variant='contained'
          sx={{
            mt: 2,
            ml: 2,
            width: '120px',
            height: '40px',
            textTransform: 'capitalize',
            fontSize: '14px',
            fontWeight: 500,
            borderRadius: '6px',
            backgroundColor: 'var(--clr-mindly-purple-hover)!important',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&.Mui-disabled': {
              backgroundColor: '#d3d3d3 !important',
              color: '#808080 !important',
            },
            position: 'relative',
          }}
          onClick={() => handleSubmit(goalId || goalCollectionID)}
          disabled={isDisabled || isSaving}
        >
          {isSaving ? (
            <CircularProgress
              size={20}
              sx={{
                color: 'white',
              }}
            />
          ) : (
            'Save'
          )}
        </Button>
      )}
    </Box>
  );
};

export default FormActions;
